import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=96a9c77c&scoped=true&"
import script from "./Checkboxes.vue?vue&type=script&lang=js&"
export * from "./Checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./Checkboxes.vue?vue&type=style&index=0&id=96a9c77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a9c77c",
  null
  
)

export default component.exports